import styled from "styled-components";

export const FormWrapper = styled.div`
    .comment_ask{
        &_top{
            &_form{
                textarea{
                    height: 100px;
                    max-height: 100px;
                    width: 100%;
                    padding: 8px;
                    font-size: 1.0rem;
                    color: #000000;
                    outline: none;
                    border: none;
                    resize: none;
                    border-bottom: 1px solid #e2c1c1;
                    border-top-left-radius: 4px;
                    border-top-right-radius: 4px;
                }
                border: 1px solid #e2c1c1;
                border-radius: 4px;
                div{
                    display: flex;
                    justify-content: space-between;
                    height: 100%;
                    padding: 0 12px 8px 12px;
                    button{
                        position: relative;
                        float: right;
                        height: 30px;
                        width: 150px;
                        outline: none;
                        border:  none;
                        background-color: #2f80ed;
                        color: #f0f0f0;
                        border-radius: 4px;
                        &:hover{
                            background-color: rgb(106, 39, 174);
                        }
                    }
                    p{
                        font-style: italic;
                        color: #ff6801;
                        font-size: 0.9rem;
                        padding: 0;
                        margin: 0;
                    }
                }
                margin-bottom: 12px;
            }
           
        }
    }
`
